<template>
  <div>   
    <l-map
      ref="map"   
      @ready="getMapBounds"
      @moveend="getMapBounds"
      :zoom="zoom" :center="center" :options="{zoomControl:false}"> 
      <l-control-zoom position="bottomright"></l-control-zoom>
      <l-tile-layer
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        layer-type="base"
      />
      <v-marker-cluster>
        <l-circle-marker
          v-for="circle in dataCircles"
          :key="circle.id"
          :lat-lng="[circle.lat, circle.lon]"
          :radius="6"
          fill-color="red"
          color="red"
          :fill-opacity="1"
        >
          <l-popup >
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">
                  {{ circle.Title }}
                  <span class="blue--text text--darken-4">
                    <span v-if="circle.id"> ID: {{ circle.id }} </span>
                  </span>                
                </h5>

                <ul class="list-group list-group-flush">
                  <!-- 1st row -->
                  <li class="list-group-item row mt-1">
                    <v-row class="mx-1 my-1">
                      <v-col cols="4" class="font-weight-bold">
                        <v-icon>mdi-shape</v-icon> Type
                      </v-col>
                      <v-col cols="8" class="text-left">
                        <span v-if="circle.report_type">{{ circle.report_type }}</span>
                       </v-col>
                    </v-row>
                  </li>

                  <!-- 2nd row -->
                  <li class="list-group-item row">
                    <v-row class="mx-1 my-1">
                      <v-col cols="4" class="font-weight-bold">
                        <v-icon>mdi-clock </v-icon> Time
                      </v-col>
                      <v-col cols="8">
                        <span v-if="circle.report_time">{{ circle.report_time }}</span>
                      </v-col>
                    </v-row>
                  </li>
                 
                 <!-- 3rd row -->
                  <li class="list-group-item row">
                    <v-row class="mx-1 my-1">
                      <v-col cols="4" class="font-weight-bold" title="Location">
                        <v-icon>mdi-map-marker</v-icon>
                        Location</v-col>
                      <v-col cols="8" title="Location">
                       {{circle.road_name}}
                      </v-col>
                    </v-row>
                  </li>

                 <!-- 3rd row -->
                  <li class="list-group-item row" v-if="circle.description">
                    <v-row class="mx-1 my-1">
                      <v-col cols="4" class="font-weight-bold" title="Location">
                        <v-icon>mdi-map-marker</v-icon>
                        Description</v-col>
                      <v-col cols="8" title="Location">
                       {{circle.description}}
                      </v-col>
                    </v-row>
                  </li>
                  
                </ul>
              </div>
            </div>
          </l-popup>
        </l-circle-marker>
      </v-marker-cluster>   
    </l-map>
  </div>
</template>

<style>
@import "../assets/static/css/app.scss";
@import "../assets/static/css/MarkerCluster.css";
</style>

<script>

import "leaflet";
import { icon } from "leaflet";
import {
  LMap,
  LTileLayer,
  // LMarker,
  LCircleMarker,
  LPopup,
  LControlZoom
} from "vue2-leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import axios from "axios";


export default {
  name: "Mapview",
  props: ["update_filter", "selected_sources"],
  components: {
    LMap,
    LTileLayer,
    // LMarker,
    LCircleMarker,
    LPopup,
    LControlZoom,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
  },
  data() {
    return {
      loading: false,
      zoom: 10,
      center: [38.83154, -77.31114],
      country_geojson: null,
      tileProviders: [
        {
          name: "OpenStreet",
          visible: true,
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        },
      ],
      dataCircles: [],
      tooLong: true,
      icon: null,
      domain: this.$domain,
      mapBounds: null,
    };
  },
  computed: {

  },
  methods: {
    addIcon(Mode){
      const m = Mode.length > 1 ? Mode[0]: Mode 
      return icon({
      iconUrl:this.$domain + "/static/images/"+ m +".png",
      iconSize: [32, 32],
      iconAnchor: [16, 37],
      popupAnchor: [0, -40]
    })
    },

    async getData() {
      // console.log('getData', this.selected_sources)
      const path = this.$domain + "/map/get_data";
      axios.post(
        path,
        {
          'data_sources': this.selected_sources,
        }
      ).then((res) => {
        // console.log(res.data);
        this.dataCircles = res.data;
        // this.$parent.project_cnt = res.data.length
      });
    },
    getMapBounds () {
      // console.log(this.$refs.map)
      // console.log(this.$refs.map.mapObject.getBounds())
      // this.mapBounds = this.$refs.map;
      // console.log(this.mapBounds)
    },

},
  async created() {
    // this.getGeojson()
    this.getData();
  },
  watch: {
     update_filter(){
      //  console.log("watch, updating filter", this.selected_sources)
      this.getData()
    }
  },
};
</script>